export default __webpack_public_path__ + "static/media/brand_06.6ae29d07.png";